"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockRetailLocationsModule = void 0;
// external
const inversify_1 = require("inversify");
const mockRetailLocations_1 = require("./data/mockRetailLocations");
let MockRetailLocationsModule = class MockRetailLocationsModule {
    constructor(_httpConnection) {
        this._httpConnection = _httpConnection;
        this.mockRetailLocations = mockRetailLocations_1.mockRetailLocations;
    }
    async setOrderingStatus(retailLocationId, orderingStatus) {
        const i = this.mockRetailLocations.findIndex(rl => rl.retailLocationId === retailLocationId);
        if (i === -1) {
            throw new Error("Could not find retail location.");
        }
        this.mockRetailLocations[i].orderingStatus.location = orderingStatus;
    }
    retrieveSyncedRetailLocations() {
        return {
            mockData: this.mockRetailLocations
        };
    }
    async checkCanServiceOrder(retailLocationId, orderType, requestedReadyTime, currentPosition) {
        return {
            available: true
        };
    }
};
MockRetailLocationsModule = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)("HttpConnection"))
], MockRetailLocationsModule);
exports.MockRetailLocationsModule = MockRetailLocationsModule;
//# sourceMappingURL=MockRetailLocationsModule.js.map